angular.module('app')
	.controller('RegisterVendorCtrl', function (
		$scope,
		$rootScope,
		$timeout,
		validationService,
		$userService,
		$configService,
		$uniService,
		$location,
		$portalService,
		$menuService,
		$financialApiService,
		$giuridicVersion,
		$privacyService,
		$modalService,
		$download
	) {
		var regForVowels = /[AEIOU]/gi;
		var regForConsonants = /[^AEIOU]/gi;



		$menuService.hide();
		$scope.firstLoginFormObj = {
			idParent: null, //id utente
			identifier: $scope.cfInput,
			name: $scope.nameInput + ' ' + $scope.surnameInput,
			radioTrattamentoDati: false,
			radioCondizioniGenerali: false,
			radioNormeCondizioniGenerali: false,
			albaCheckbox: false
		}

		$scope.onInit = function () {
			$rootScope.$broadcast("pageLoader", {
				action: "OPEN"
			});
			$scope.getPrivacyEnrollment();


			$scope.disableInput = {
				name: false,
				surname: false,
				cellulare: false,
				cf: false
			}

			$scope.controlPrivacy = {
				enablePrivacyView: true,
				cf: null,
				piva: null,
				disablePrivacyTest: false
			}

			$('.bg-header').hide();
			$scope.otpCheckEnabled = false;
			$scope.otpInputEnabled = true;
			$scope.privacyEnabled = false;
			$scope.registerUser = {};
			$scope.validationService = validationService;
			$rootScope.isRegisterVendor = true;
			$scope.video = {
				'isVisible': true,
				'toggle': function () {
					$scope.video.isVisible === true ? $scope.video.isVisible = false : $scope.video.isVisible = true;
				}
			}
			$scope.screenProperties = {
				'width': $(window).width(),
				'height': $(window).height()
			}

			$scope.logout = function () {
				$configService.logout();
			};

			//TODO

			$scope.registerUser.email = "";
			$scope.registerUser.type = "DEALER";
			$scope.registerUser.bankCode = "ALBA";
			$scope.typeUser = $configService.getUser().type;
			$scope.registerUser.identifier = $configService.getUser().identifier;
			$scope.title = "Dichiaro di avere i poteri di firma per la società " + $configService.getUser().name + " con codice fiscale " + $configService.getUser().identifier;
			if ($scope.typeUser != "CUSTOMER_IL" && $scope.typeUser != "PROVISIONAL") {

				$scope.populateFileds($configService.getUser());
				$scope.title = "Dichiaro di avere un ruolo rilevante per l'azienda ";
				if ($scope.typeUser == 'SIGNER') {
					$scope.firstLoginFormObj.albaPoteriDiFirma = true;
				}
			}

			$scope.controlPrivacy.cf = $configService.getUser().identifier;
			$scope.controlPrivacy.piva = $configService.getUser().piva;


		}

		$scope.isFormValid = function (form, index) {
			var allRadioChecked = $scope.listaConsensi &&
				$scope.listaConsensi
					.every(function (domanda) {
						return domanda.checked === true;
					})

			if ($scope.controlPrivacy.disablePrivacyTest) {

				return !form.$invalid &&
					$scope.registerUser.cf &&
					$scope.registerUser.name &&
					$scope.registerUser.surname &&
					$scope.registerUser.cellulare &&
					$scope.firstLoginFormObj.albaCheckbox &&
					$scope.firstLoginFormObj.albaPoteriDiFirma &&
					!$scope.errorDataInput &&
					$scope.firstLoginFormObj.radioCondizioniGenerali &&
					$scope.firstLoginFormObj.radioNormeCondizioniGenerali


			} else {

				if ($scope.listaConsensi && typeof index != "undefined") {
					$scope.listaConsensi[index].accepted = $scope.listaConsensi[index].esito;
				}

				var testPrivacy = $scope.listaConsensi && $scope.listaConsensi
					.filter(function (consenso) {
						return !!consenso.obbligatorio;
					})
					.every(function (consensoObbligatorio) {
						return consensoObbligatorio.esito === true;
					})

				return !form.$invalid &&
					$scope.registerUser.cf &&
					$scope.registerUser.name &&
					$scope.registerUser.surname &&
					$scope.registerUser.cellulare &&
					$scope.firstLoginFormObj.albaCheckbox &&
					$scope.firstLoginFormObj.albaPoteriDiFirma &&
					$scope.documentPrivacyDownloaded &&
					!$scope.errorDataInput &&
					$scope.firstLoginFormObj.radioCondizioniGenerali &&
					$scope.firstLoginFormObj.radioNormeCondizioniGenerali &&
					testPrivacy &&
					allRadioChecked

			}


		}

		$scope.checkAlba = function (a) {
			$scope.firstLoginFormObj.albaCheckbox = !$scope.firstLoginFormObj.albaCheckbox;
		}

		$scope.checkAlbaPoteriDiFirma = function (a) {
			$scope.firstLoginFormObj.albaPoteriDiFirma = !$scope.firstLoginFormObj.albaPoteriDiFirma
		}

		$scope.checkLang = function (lang) {
			if ($rootScope.selectedLanguage == lang)
				return (true);
			else
				return (false);
		}




		$scope.firstLoad = function () {
			$('#trattamentoDati').mCustomScrollbar({
				theme: "dark",
				scrollbarPosition: "outside",
				callbacks: {
					onInit: function () {
						$(this).data("mCS").opt.callbacks.onTotalScrollOffset = Math.abs(this.mcs.content.innerHeight() - ($("#trattamentoDati").position().top + $("#trattamentoDati").outerHeight(true)));
					},
					onTotalScroll: function () {
						var scrollbarHeight = parseInt($('#trattamentoDati').css('padding-top').slice(0, -2)) * 2 + $('#trattamentoDati').height();
						var dragger = $('#trattamentoDati .mCSB_dragger');
						var draggerHeight = dragger.height();
						var currentDraggerPosition = parseInt(dragger.css('top').slice(0, -2));
						if (currentDraggerPosition + draggerHeight == scrollbarHeight) {
							$('#radioTrattamentoDati-container').removeClass('disabled-item');
						}
						var idx = $(this).data("mCS").idx;

					},
					alwaysTriggerOffsets: false
				}
			});
			$('#condizioniGenerali').mCustomScrollbar({
				theme: "dark",
				scrollbarPosition: "outside",
				callbacks: {
					onInit: function () {
						$(this).data("mCS").opt.callbacks.onTotalScrollOffset = Math.abs(this.mcs.content.innerHeight() - ($("#condizioniGenerali").position().top + $("#condizioniGenerali").outerHeight(true)));
					},
					onTotalScroll: function () {
						console.log('onTotalScroll');

						var scrollbarHeight = parseInt($('#condizioniGenerali').css('padding-top').slice(0, -2)) * 2 + $('#condizioniGenerali').height();
						var dragger = $('#condizioniGenerali .mCSB_dragger');
						var draggerHeight = dragger.height();
						var currentDraggerPosition = parseInt(dragger.css('top').slice(0, -2));
						if (currentDraggerPosition + draggerHeight == scrollbarHeight) {
							$('#radioCondizioniGenerali-container').removeClass('disabled-item');
						}
						var idx = $(this).data("mCS").idx;

					},
					alwaysTriggerOffsets: true
				}
			});
			$('#normeCondizioniGenerali').mCustomScrollbar({
				theme: "dark",
				scrollbarPosition: "outside",
				callbacks: {
					onInit: function () {
						$(this).data("mCS").opt.callbacks.onTotalScrollOffset = Math.abs(this.mcs.content.innerHeight() - ($("#normeCondizioniGenerali").position().top + $("#normeCondizioniGenerali").outerHeight(true)));
					},
					onTotalScroll: function () {
						var scrollbarHeight = parseInt($('#normeCondizioniGenerali').css('padding-top').slice(0, -2)) * 2 + $('#normeCondizioniGenerali').height();
						var dragger = $('#normeCondizioniGenerali .mCSB_dragger');
						var draggerHeight = dragger.height();
						var currentDraggerPosition = parseInt(dragger.css('top').slice(0, -2));
						if (currentDraggerPosition + draggerHeight == scrollbarHeight) {
							$('#radioNormeCondizioniGenerali-container').removeClass('disabled-item');
						}
						var idx = $(this).data("mCS").idx;

					},
					alwaysTriggerOffsets: false
				}
			});

			if (!$scope.hasScrollBar('#condizioniGenerali')) {
				console.log('no scrollbar');
				$('#radioCondizioniGenerali-container').removeClass('disabled-item');
			}
			if (!$scope.hasScrollBar('#normeCondizioniGenerali')) {
				$('#radioNormeCondizioniGenerali-container').removeClass('disabled-item');
			}
			if (!$scope.hasScrollBar('#trattamentoDati')) {
				$('#radioTrattamentoDati-container').removeClass('disabled-item');
			}


			console.log('ONLOAD DIV PRIVACY2 END');

			scrollBar();
		}


		$scope.hasScrollBar = function (id) {
			return $(id + ' .mCSB_container').height() > $(id).height() ? true : false
		}


		$scope.registerVendor = function (fromModal) {
			$scope.disabledButton = true;
			var appUser = $scope.registerUser;
			appUser.tel = $scope.registerUser.cellulare;
			if (!$scope.existValidPrivacy) {
				appUser.privacy = {
					listaConsensi: $scope.listaConsensi,
					legalForm: $scope.legalForm,
					moduleCode: $scope.moduleCode
				}
			} else {
				appUser.privacy = {
					legalForm: $scope.legalForm,
					moduleCode: $scope.moduleCode
				}
			}

			if ($scope.typeUser == "CUSTOMER_IL" && !fromModal) {

				$modalService.openModal('confirmNumber-modal');

			} else {
				$modalService.closeModal('confirmNumber-modal');
				$userService.insertAppUser(appUser)
					.then(function (response) {
						console.log("InsertAppUser: ", response);
						$scope.errorMessageLogin = response.success;

						if (response.success) {
							$scope.firstLoginFormObj.name = $scope.nameInput + ' ' + $scope.surnameInput;
							$scope.firstLoginFormObj.identifier = $scope.cfInput;
							$timeout(function () {
								location.reload();
								$location.path('/');
							}, 100);
						}
						$scope.disabledButton = false;
					})
					.catch(function (erro) {
						$scope.disabledButton = false;
					});

			}


		}

		$scope.closeModal = function () {
			$modalService.closeModal('confirmNumber-modal');
			$scope.disabledButton = false;
		}

		$scope.onNameChanges = function (input) {
			$scope.registerUser.name = input.value;
			var cf = {
				value: $scope.registerUser.cf
			}
			$scope.checkWithName(cf);
		}

		$scope.onSurnameChanges = function (input) {
			$scope.registerUser.surname = input.value;
			var cf = {
				value: $scope.registerUser.cf
			}
			$scope.checkWithName(cf);
		}

		$scope.checkWithName = function (input) {
			var cf = input.value;
			//touched
			if ($scope.firstLoginForm.nameInput && $scope.firstLoginForm.surnameInput && !$scope.firstLoginForm.nameInput.$touched ||
				!$scope.firstLoginForm.surnameInput.$touched) {
				console.info('didnt touch all inputs!');
				return;
			}

			if (!$scope.registerUser.surname || !$scope.registerUser.name) {
				$scope.errorDataInput = true;
				$scope.otpCheckEnabled = false;
				return;
			}

			var registerUser = Object.assign({}, $scope.registerUser);

			var checkCfValid = validationService
				.checkCf(cf, $scope.firstLoginForm, 'cfInput');

			var cognome = registerUser.surname
				.toUpperCase()
				.replace(/[']/g, "")
				.replace(/ /gi, "")
				.replace(/\s/g, '')
				.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A")
				.replace(/È|É|Ê|Ë/gi, "E")
				.replace(/Ì|Í|Î|Ï/gi, "I")
				.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O")
				.replace(/Ù|Ú|Û|Ü/gi, "U")
				.match(regForConsonants)
				.concat(registerUser.surname
					.match(regForVowels))
				.concat("X");

			var temp = registerUser.name
				.toUpperCase()
				.replace(/[']/g, "")
				.replace(/ /gi, "")
				.replace(/\s/g, '')
				.replace(/À|Á|Â|Ã|Ä|Ä|Å/gi, "A")
				.replace(/È|É|Ê|Ë/gi, "E")
				.replace(/Ì|Í|Î|Ï/gi, "I")
				.replace(/Ò|Ó|Ô|Õ|Ö/gi, "O")
				.replace(/Ù|Ú|Û|Ü/gi, "U")
				.match(regForConsonants);
			if (temp.length > 3) {
				temp.splice(1, 1);
				console.log('Codice Fiscale test: ', temp);
			}
			var nome = temp.concat(registerUser.name
				.match(regForVowels))
				.concat("X");
			nome = nome.join('').toUpperCase().substr(0, 3);
			cognome = cognome.join('').toUpperCase().substr(0, 3);

			if (checkCfValid && cf && (cognome.concat(nome) == cf.toUpperCase().substr(0, 6))) {
				$scope.otpCheckEnabled = true;
				$scope.errorDataInput = false;
			} else {
				$scope.otpCheckEnabled = false;
				$scope.errorDataInput = true;
			}


		}

		$scope.populateFileds = function (user) {

			var campi = ['nome', 'cognome', 'cellulare', 'cf'];


			$scope.registerUser.name = user && user.name && user.name;
			$scope.registerUser.surname = user && user.surname && user.surname;
			$scope.registerUser.cellulare = user && user.tel && user.tel;
			$scope.registerUser.cf = user && user.identifier && user.identifier;



			campi.forEach(function (key) {

				switch (key) {
					case 'nome':
						$scope.disableInput.name = $scope.registerUser.name ? true : false;
						break;

					case 'cognome':
						$scope.disableInput.surname = $scope.registerUser.surname ? true : false;
						break;

					case 'cellulare':
						$scope.disableInput.cellulare = ($scope.registerUser.cellulare && validationService.phoneRegex.test($scope.registerUser.cellulare)) ? true : false;
						break;

					case 'cf':
						$scope.disableInput.cf = $scope.registerUser.cf ? true : false;
						break;

					default:
						break;
				}
			})

		}

		$scope.getPrivacyEnrollment = function () {
			$financialApiService.getPrivacyEnrollment()
				.then(function (response) {
					$scope.existValidPrivacy = response.existValidPrivacy;
					$scope.listaConsensi = response.listaConsensi;
					$scope.legalForm = response.legalForm;
					$scope.moduleCode = response.moduleCode;
					$rootScope.$broadcast("pageLoader", {
						action: "CLOSE"
					});
					mapConsensi();
					if (response.valid === true) {
						$scope.controlPrivacy.enablePrivacyView = false;
						$scope.controlPrivacy.disablePrivacyTest = true;
					}

				})
				.catch(function (error) {
					console.log(error);
					$rootScope.$broadcast("pageLoader", {
						action: "CLOSE"
					});
				})
		}

		$scope.generateLinkForPrivacy = function (formaGiuridica) {
			var filename = '';
			if ($giuridicVersion.isDittaIndividuale(formaGiuridica)) {
				filename = 'PRIVACY_DIN';
			} else {
				filename = 'PRIVACY';
			}

			var url = '/uni/download/service-infos/' +
				encodeURIComponent(filename) + '/'

			$download.getGenericDownload(url)
				.then(function (response) {
					console.log(response);
				})

		}

		$scope.downloadPrivacy = function () {
			$scope.documentPrivacyDownloaded = true;
		}

		var mapConsensi = function () {
			$scope.listaConsensi = $scope.listaConsensi && $scope.listaConsensi
				.map(function (element) {
					return {
						accepted: element.accepted,
						domanda: element.domanda,
						esito: element.esito,
						idModulo: element.idModulo,
						identifier: element.identifier,
						index: element.index,
						obbligatorio: element.obbligatorio,
						validFrom: element.validFrom,
						checked: false
					}
				})
		}

		$scope.checkRadio = function (form, index) {

			$scope.listaConsensi[index].checked = true;
			$scope.isFormValid(form, index);

		}
	});